"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getMemoryStorage = function getMemoryStorage() {
  return {
    data: {},
    getItem: function getItem(key) {
      return this.data[key];
    },
    setItem: function setItem(key, value) {
      this.data[key] = value;
    },
    removeItem: function removeItem(key) {
      delete this.data[key];
    },
    removeAll: function removeAll() {
      this.data = {};
    }
  };
};
var WebStorage = /*#__PURE__*/function () {
  function WebStorage(storage) {
    _classCallCheck(this, WebStorage);
    this.storageImpl = storage;
    try {
      var testKey = 'test-key';
      this.set(testKey, '1');
      this.remove(testKey);
    } catch (error) {
      this.storageImpl = getMemoryStorage();
    }
  }
  return _createClass(WebStorage, [{
    key: "get",
    value: function get(key) {
      var value = this.storageImpl.getItem(key);
      return value ? JSON.parse(value) : value;
    }
  }, {
    key: "getAsString",
    value: function getAsString(key) {
      return this.storageImpl.getItem(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      return this.storageImpl.setItem(key, typeof value !== 'string' ? JSON.stringify(value) : value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      return this.storageImpl.removeItem(key);
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      return this.storageImpl.clear();
    }
  }]);
}();
var _localInstance;
var _sessionInstance;
var _default = exports["default"] = {
  getInstance: function getInstance() {
    if (!_localInstance) {
      var storage = typeof window === 'undefined' ? {} : window.localStorage || {};
      _localInstance = new WebStorage(storage);
    }
    return _localInstance;
  },
  getSessionInstance: function getSessionInstance() {
    if (!_sessionInstance) {
      var storage = typeof window === 'undefined' ? {} : window.sessionStorage || {};
      _sessionInstance = new WebStorage(storage);
    }
    return _sessionInstance;
  },
  // unit testing only
  reset: function reset() {
    _localInstance = _sessionInstance = null;
  }
};